import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2eb3ce10 = () => interopDefault(import('../pages/404/index.vue' /* webpackChunkName: "pages/404/index" */))
const _623f5333 = () => interopDefault(import('../pages/checkUser/index.vue' /* webpackChunkName: "pages/checkUser/index" */))
const _efd7d140 = () => interopDefault(import('../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _39a630d8 = () => interopDefault(import('../pages/dashboard/index.vue' /* webpackChunkName: "pages/dashboard/index" */))
const _5dde2ed8 = () => interopDefault(import('../pages/learn-more/index.vue' /* webpackChunkName: "pages/learn-more/index" */))
const _69f0e0a9 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _422ecb60 = () => interopDefault(import('../pages/logout/index.vue' /* webpackChunkName: "pages/logout/index" */))
const _e5c5930e = () => interopDefault(import('../pages/register/index.vue' /* webpackChunkName: "pages/register/index" */))
const _4b06186c = () => interopDefault(import('../pages/soundcloud-callback/index.vue' /* webpackChunkName: "pages/soundcloud-callback/index" */))
const _494a370f = () => interopDefault(import('../pages/d/featured/index.vue' /* webpackChunkName: "pages/d/featured/index" */))
const _7307f096 = () => interopDefault(import('../pages/d/new/index.vue' /* webpackChunkName: "pages/d/new/index" */))
const _5db57db5 = () => interopDefault(import('../pages/login/complete/index.vue' /* webpackChunkName: "pages/login/complete/index" */))
const _5e3bf142 = () => interopDefault(import('../pages/login/forgot/index.vue' /* webpackChunkName: "pages/login/forgot/index" */))
const _f0d07eae = () => interopDefault(import('../pages/login/reset/index.vue' /* webpackChunkName: "pages/login/reset/index" */))
const _226106b2 = () => interopDefault(import('../pages/user/settings/index.vue' /* webpackChunkName: "pages/user/settings/index" */))
const _5ab35419 = () => interopDefault(import('../pages/d/featured/desktop.vue' /* webpackChunkName: "pages/d/featured/desktop" */))
const _710c607a = () => interopDefault(import('../pages/d/new/blank/index.vue' /* webpackChunkName: "pages/d/new/blank/index" */))
const _43f87fc0 = () => interopDefault(import('../pages/d/new/card/index.vue' /* webpackChunkName: "pages/d/new/card/index" */))
const _6c83efaf = () => interopDefault(import('../pages/d/new/_dropId/index.vue' /* webpackChunkName: "pages/d/new/_dropId/index" */))
const _92b0b13e = () => interopDefault(import('../pages/v2/d/_dropId/index.vue' /* webpackChunkName: "pages/v2/d/_dropId/index" */))
const _0712775e = () => interopDefault(import('../pages/d/_dropId/index.vue' /* webpackChunkName: "pages/d/_dropId/index" */))
const _0692f99d = () => interopDefault(import('../pages/m/_media/index.vue' /* webpackChunkName: "pages/m/_media/index" */))
const _1d2e5c52 = () => interopDefault(import('../pages/d/_dropId/preview/index.vue' /* webpackChunkName: "pages/d/_dropId/preview/index" */))
const _3a55fa2e = () => interopDefault(import('../pages/d/_dropId/share/index.vue' /* webpackChunkName: "pages/d/_dropId/share/index" */))
const _e9947e8e = () => interopDefault(import('../pages/d/_dropId/test/index.vue' /* webpackChunkName: "pages/d/_dropId/test/index" */))
const _67332da0 = () => interopDefault(import('../pages/d/_dropId/update/index.vue' /* webpackChunkName: "pages/d/_dropId/update/index" */))
const _a3c2b5d4 = () => interopDefault(import('../pages/m/_media/preview/index.vue' /* webpackChunkName: "pages/m/_media/preview/index" */))
const _32c9ecc8 = () => interopDefault(import('../pages/d/_dropId/qr/_locationId/index.vue' /* webpackChunkName: "pages/d/_dropId/qr/_locationId/index" */))
const _a68668e2 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _d30c4c72 = () => interopDefault(import('../pages/_handle/index.vue' /* webpackChunkName: "pages/_handle/index" */))
const _4e1a2186 = () => interopDefault(import('../pages/_handle/go/index.vue' /* webpackChunkName: "pages/_handle/go/index" */))
const _7ab7f4dd = () => interopDefault(import('../pages/_handle/nearby/index.vue' /* webpackChunkName: "pages/_handle/nearby/index" */))
const _229227c6 = () => interopDefault(import('../pages/_handle/go/reset/index.vue' /* webpackChunkName: "pages/_handle/go/reset/index" */))
const _78921154 = () => interopDefault(import('../pages/_handle/go/_category/index.vue' /* webpackChunkName: "pages/_handle/go/_category/index" */))
const _17eeaa25 = () => interopDefault(import('../pages/_handle/p/_place/index.vue' /* webpackChunkName: "pages/_handle/p/_place/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _2eb3ce10,
    name: "404"
  }, {
    path: "/checkUser",
    component: _623f5333,
    name: "checkUser"
  }, {
    path: "/contact",
    component: _efd7d140,
    name: "contact"
  }, {
    path: "/dashboard",
    component: _39a630d8,
    name: "dashboard"
  }, {
    path: "/learn-more",
    component: _5dde2ed8,
    name: "learn-more"
  }, {
    path: "/login",
    component: _69f0e0a9,
    name: "login"
  }, {
    path: "/logout",
    component: _422ecb60,
    name: "logout"
  }, {
    path: "/register",
    component: _e5c5930e,
    name: "register"
  }, {
    path: "/soundcloud-callback",
    component: _4b06186c,
    name: "soundcloud-callback"
  }, {
    path: "/d/featured",
    component: _494a370f,
    name: "d-featured"
  }, {
    path: "/d/new",
    component: _7307f096,
    name: "d-new"
  }, {
    path: "/login/complete",
    component: _5db57db5,
    name: "login-complete"
  }, {
    path: "/login/forgot",
    component: _5e3bf142,
    name: "login-forgot"
  }, {
    path: "/login/reset",
    component: _f0d07eae,
    name: "login-reset"
  }, {
    path: "/user/settings",
    component: _226106b2,
    name: "user-settings"
  }, {
    path: "/d/featured/desktop",
    component: _5ab35419,
    name: "d-featured-desktop"
  }, {
    path: "/d/new/blank",
    component: _710c607a,
    name: "d-new-blank"
  }, {
    path: "/d/new/card",
    component: _43f87fc0,
    name: "d-new-card"
  }, {
    path: "/d/new/:dropId",
    component: _6c83efaf,
    name: "d-new-dropId"
  }, {
    path: "/v2/d/:dropId",
    component: _92b0b13e,
    name: "v2-d-dropId"
  }, {
    path: "/d/:dropId",
    component: _0712775e,
    name: "d-dropId"
  }, {
    path: "/m/:media",
    component: _0692f99d,
    name: "m-media"
  }, {
    path: "/d/:dropId?/preview",
    component: _1d2e5c52,
    name: "d-dropId-preview"
  }, {
    path: "/d/:dropId?/share",
    component: _3a55fa2e,
    name: "d-dropId-share"
  }, {
    path: "/d/:dropId?/test",
    component: _e9947e8e,
    name: "d-dropId-test"
  }, {
    path: "/d/:dropId?/update",
    component: _67332da0,
    name: "d-dropId-update"
  }, {
    path: "/m/:media?/preview",
    component: _a3c2b5d4,
    name: "m-media-preview"
  }, {
    path: "/d/:dropId?/qr/:locationId",
    component: _32c9ecc8,
    name: "d-dropId-qr-locationId"
  }, {
    path: "/",
    component: _a68668e2,
    name: "index"
  }, {
    path: "/:handle",
    component: _d30c4c72,
    name: "handle"
  }, {
    path: "/:handle/go",
    component: _4e1a2186,
    name: "handle-go"
  }, {
    path: "/:handle/nearby",
    component: _7ab7f4dd,
    name: "handle-nearby"
  }, {
    path: "/:handle/go/reset",
    component: _229227c6,
    name: "handle-go-reset"
  }, {
    path: "/:handle/go/:category",
    component: _78921154,
    name: "handle-go-category"
  }, {
    path: "/:handle/p/:place",
    component: _17eeaa25,
    name: "handle-p-place"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
